import React, { useEffect, useState } from 'react';
export function TopUrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 59); // 14:59 en segundos

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const today = new Date().toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long'
  });
  return <div className="fixed left-0 right-0 top-0 z-[60] border-b-2 border-[#D89A3D] bg-[#0A0A0A] px-4 py-2 shadow-lg" data-id="element-391" data-mp="1mh93rtqpxive">
      <div className="mx-auto flex max-w-content items-center justify-center gap-4" data-id="element-392" data-mp="17sw2ch8v37ti">
        <div className="flex flex-col items-center text-center" data-id="element-393" data-mp="1cq62aqtvn1vl">
          <p className="font-display text-[11px] font-extrabold uppercase leading-tight tracking-wide text-[#D89A3D] sm:text-sm" data-id="element-394" data-mp="yr6chfumogxu">
            OFERTA EXCLUSIVA SOLO POR HOY <br className="sm:hidden" data-id="element-395" data-mp="13pq0rmwp24td" />
            {today.toUpperCase()}
          </p>
          <p className="mt-0.5 text-[10px] text-[#EFEDE8]/80 sm:text-xs" data-id="element-396" data-mp="3kgg025i7zz36">
            Últimos <span className="font-bold text-[#FF7A00]" data-id="element-397" data-mp="3ggxdz6enxhyr">4 cupos</span> al precio
            promocional + 8 Bonos
          </p>
        </div>
        <div className="flex shrink-0 items-center justify-center rounded-md bg-[#181512] px-3 py-1.5 font-numeric text-lg font-bold tracking-wider text-[#F8F3EA] shadow-inner sm:text-xl" data-id="element-398" data-mp="3uf5ibze13ljy">
          {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
        </div>
      </div>
    </div>;
}